import React, { useState } from "react";
// import { submitFirmDetails } from "../../auth/services/privateapicalling";
import { useSelector } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router";
import { initiateGcaPayment, initiatePayment } from "../../auth/services/privateapicalling";
import axios from "axios";
import useCommonServices from "../../../hooks/useCommonServices";
import { toast, ToastContainer } from "react-toastify";


interface PaymentProps {
  onPrev: () => void;
  applicationId: string | null;
  existData: any;
  fetchApplicationExistenceCheck: () => Promise<void>;
}

const Payment
: React.FC <PaymentProps>= ({onPrev, applicationId,existData}) => {
 const language = useSelector((state:any)=>state.auth.language);
  const [showModal, setShowModal] = useState(false);
 const [submitLoading,setSubmitLoading] = useState(false)

    const {doPayment} = useCommonServices();
  
    //.log("applicationId", existData);
    const token = useSelector((state:any)=>state.auth.token)
    const userdetails = useSelector((state:any)=>state.auth.userDetails)
    const [paymentType, setPaymentType] = useState("NB");
    const appId = userdetails.applicationId
    const licenseType = "1";
    const entityType="FPO";
  const navigate = useNavigate();

 
  // Navigate to Preview Screen
  const onPreview = () => {
    //.log("Navigating to preview screen...");
    // Add navigation logic here
     navigate(`/gca-application/${applicationId}`)
  };

  // Handle Form Submission
  const goTopayment =async () => {
     try {
        setSubmitLoading(true);
          const body = {
        applicationId:applicationId,
        "payMode":paymentType
      }
          const res =  await initiateGcaPayment(body,token);
       

          if(res?.data?.success){
            setShowModal(true);
          }else{
            toast.error("Submission failed. Please try again.",
            {
              position: "top-right",
              autoClose: 5000,
            });
          }
        
          

        
        } catch (error) {
          //.error("Error fetching HTML:", error);
        }finally{
          setSubmitLoading(false);
        }
    
    
   
   
  };

  const gotoMyApplication = ()=>{
    navigate('/gca-my-application'  );
  }

 



  return (
    <>
 
    
   <div className="card">
      <div className="card-header">
        <h6 className="card-title">
        Application ID-{`${applicationId}`}
        </h6>
      </div>
      <div className="card-body">
      <div className="row">

    <div className="d-flex flex-column align-items-center mt-3">
      <button type="button" className="btn btn-primary mb-4" onClick={onPreview}>
        {language.preview_application}
      </button>
      {/* <div className="fs-18 mb-4 mt-2">
        Your License Fee is <strong className="text-success">{getLicenseFee(licenseType, entityType)} </strong><span className="me-2">!!</span> <span className="text-danger">  Excluding GST</span>
      </div> */}
   
      <button type="button" className="btn btn-info btn-lg p-2 fs-3 px-4" disabled={submitLoading} onClick={goTopayment}>
        {submitLoading ? (
                      <i className="ion-load-a ion-spin"></i> // Loading spinner
                    ) : (
                      `${language.submit_application}`
                    )}
      </button> 
    
    
    </div>


    </div>
    </div>
      </div>
      <button
        type="button"
        className="btn btn-secondary"
        onClick={onPrev}
      >
        {language.previous}
      </button>

       {showModal && (
          <div className="d-block modal fade show" tabIndex={-1}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="card bg-white border-0">
                  <div className="alert alert-secondary custom-alert1">
                    <button
                      type="button"
                      className="btn-close ms-auto"
                      data-bs-dismiss="alert"
                      aria-label="Close"
                    >
                      <i className="fa-xmark fas" />
                    </button>
                    <div className="text-center pb-0 px-5">
                      <div className="custom-alert-icon">
                        <i className="flex-shrink-0 feather-check-circle" />
                      </div>
                      <h5>{language.submitted_successfully}</h5>
                      <button className="btn btn-success" onClick={gotoMyApplication}>
                        {language.done}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
         <ToastContainer  />
    </>
   
  );
};

export default Payment
;